var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('faq-banner',{attrs:{"pageObj":_vm.faqPage}}),_c('static-faq',{attrs:{"searchText":_vm.searchText}}),_c('static-footer',{attrs:{"pageObj":_vm.faqPage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }